/*
* @params:
* inputList = this.paramsInputList[this.industryNo]
* */
function simpleMultiply (inputList, stage, pieChartTitleIndex, resList, barChartList) {
  let oneStageSum = 0
  let input = inputList.input
  let pieChartTitle = inputList.pieChartTitle
  let oneBarChartList = []
  for (let i = 0; i < input[stage].length; i++) {
    if (input[stage][i].value !== '') {
      oneStageSum += input[stage][i].value * input[stage][i].factor
    }
    let val = {
      value: input[stage][i].value * input[stage][i].factor,
      label: input[stage][i].label
    }
    oneBarChartList.push(val)
  }
  let pieChartItem = {
    value: oneStageSum,
    name: pieChartTitle[pieChartTitleIndex]
  }
  resList.push(pieChartItem)
  barChartList.push(oneBarChartList)
}

function addValue (oneStageSum, label, resList, barChartList) {
  let oneBarChartList = []
  let val = {
    value: oneStageSum,
    label: label
  }
  let pieChartItem = {
    value: oneStageSum,
    name: label
  }
  oneBarChartList.push(val)
  resList.push(pieChartItem)
  barChartList.push(oneBarChartList)
}

export { simpleMultiply, addValue }
